import { useState } from "react";
import { PasswordInput } from "@/components/common";
import { useAuth, apiError } from "@/context/AuthContext";
import { Loader2, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { user, changePassword, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr("");
    if (pw.length < 12 || [/[a-z]/,/[A-Z]/,/[0-9]/,/[^a-zA-Z0-9]/].filter((r) => r.test(pw)).length < 3) {
      return setErr("La password deve avere almeno 12 caratteri e includere almeno 3 tra: minuscole, maiuscole, numeri, simboli.");
    }
    if (pw !== confirm) return setErr("Le password non coincidono.");
    setLoading(true);
    try {
      await changePassword(pw, cur);
      toast.success("Password aggiornata. Benvenuto!");
    } catch (e) { setErr(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6" data-testid="force-pw-screen">
      <form onSubmit={submit} className="w-full max-w-[360px]">
        <div className="mb-8"><Logo height={30} /></div>
        <div className="w-11 h-11 rounded-xl bg-[#FC82ED]/15 border border-[#FC82ED]/30 flex items-center justify-center text-[#FC82ED] mb-4">
          <ShieldCheck size={22} />
        </div>
        <h2 className="font-display text-[1.6rem] font-bold tracking-tight mb-1.5">Imposta la tua password</h2>
        <p className="text-sm text-slate-500 mb-7">Per la tua sicurezza, scegli una nuova password personale prima di continuare, {user?.name?.split(" ")[0]}.</p>

        <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Password attuale (quella temporanea ricevuta)</label>
        <PasswordInput testid="force-pw-current" value={cur} onChange={(e) => setCur(e.target.value)} required
               className="w-full mb-4 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 focus:border-[#FC82ED] focus:ring-2 focus:ring-[#FC82ED]/20 outline-none text-sm transition-all" placeholder="••••••••" />

        <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Nuova password</label>
        <PasswordInput testid="force-pw-new" value={pw} onChange={(e) => setPw(e.target.value)} required
               className="w-full mb-4 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 focus:border-[#FC82ED] focus:ring-2 focus:ring-[#FC82ED]/20 outline-none text-sm transition-all" placeholder="••••••••" />

        <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Conferma password</label>
        <PasswordInput testid="force-pw-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
               className="w-full mb-5 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 focus:border-[#FC82ED] focus:ring-2 focus:ring-[#FC82ED]/20 outline-none text-sm transition-all" placeholder="••••••••" />

        {err && <div data-testid="force-pw-error" className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{err}</div>}

        <button data-testid="force-pw-submit" type="submit" disabled={loading}
                className="w-full py-3 rounded-lg bg-[#FC82ED] hover:bg-[#e06dd2] text-black font-semibold text-sm transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 size={16} className="animate-spin" />} Salva e continua
        </button>
        <button type="button" onClick={logout} className="w-full mt-3 text-xs text-slate-400 hover:text-slate-600">Esci</button>
      </form>
    </div>
  );
}
